import { __rest } from 'tslib';
import { t } from '../i18n.es.js';
import React from 'react';
import { styled, Card, LazyImage, Button } from '@teko/ui';
import { CustomLink } from '../Common/CustomLink/CustomLink.es.js';

const CardContent = styled.div `
  padding: 0.5rem;
`;
const Name = styled.div `
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  height: 54px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Flex = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledCard = styled(Card)(({ outDate }) => `
  box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.1);
  ${outDate &&
    `
  filter: grayscale(100%);
  opacity: 0.6;
  `}
`);
const FromDateToDate = styled.div ``;
const CampaignItem = (_a) => {
    var { imageUrl, name, targetPath, dateFrom, dateTo } = _a, props = __rest(_a, ["imageUrl", "name", "targetPath", "dateFrom", "dateTo"]);
    const formattedDateTo = dateTo
        ? dateTo.replace(/-/g, '/')
        : '2099/12/31T12:00:00Z';
    const outDate = new Date(formattedDateTo).getTime() - new Date().getTime() < 0;
    const dateFromStr = dateFrom ? new Date(dateFrom).toLocaleDateString() : '';
    const dateToStr = dateTo ? new Date(dateTo).toLocaleDateString() : '';
    return (React.createElement(StyledCard, Object.assign({}, props, { outDate: outDate }),
        React.createElement(CustomLink, { targetPath: targetPath, targetType: "_blank" },
            React.createElement(LazyImage, { aspectRatio: 1.93, src: imageUrl })),
        React.createElement(CardContent, null,
            React.createElement(CustomLink, { targetPath: targetPath, targetType: "_blank" },
                React.createElement(Name, null, name)),
            React.createElement(Flex, null,
                React.createElement("div", null, !outDate && (React.createElement(FromDateToDate, null,
                    dateFromStr,
                    dateToStr ? ` - ${dateToStr}` : ''))),
                React.createElement(Button, { disabled: outDate, tag: "a", href: targetPath, variant: "primary" }, outDate ? t('Đã kết thúc') : t('Xem chi tiết'))))));
};

export { CampaignItem };
